import core, { GQL } from '@gin-betting/core';

import { favoritePages } from 'app-constants';

const { isOneOfPages } = core.utils;

export default function getMatchStatusesByLocation() {
    if (isOneOfPages(favoritePages.outright)) {
        return [
            GQL.SportEventStatus.NOT_STARTED,
            GQL.SportEventStatus.SUSPENDED,
            GQL.SportEventStatus.LIVE,
        ];
    }

    if (isOneOfPages(favoritePages.result)) {
        return [
            GQL.SportEventStatus.ENDED,
            GQL.SportEventStatus.LIVE,
            GQL.SportEventStatus.CLOSED,
            GQL.SportEventStatus.CANCELLED,
        ];
    }

    return [
        GQL.SportEventStatus.NOT_STARTED,
        GQL.SportEventStatus.SUSPENDED,
        GQL.SportEventStatus.LIVE,
    ];
}
